export enum SliderInputVariant {
  Green4 = '#bbe5d2',
  Green5 = 'positive',
  Orange1 = '#F9C950',
  PrimaryBlue = 'primary.blue.default',
}
